import { render, staticRenderFns } from "./OneSubDetailDescItem.vue?vue&type=template&id=1122a4f9&"
import script from "./OneSubDetailDescItem.vue?vue&type=script&lang=js&"
export * from "./OneSubDetailDescItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports